import { getMonogramFromName } from 'util/participant';
import React, { useEffect, useState } from 'react';
import { WaitingUserInfo } from 'api/types';
import { useCache } from 'useCase/cache/useCache';
import { useIsMounted } from 'ui/hooks/useIsMounted';
import { getWaitingUserDisplayName } from 'features/AccessRequests/utils/getWaitingUserDisplayName';
import { ListItemAvatar, ListItemAvatarImage } from 'features/Modals/ParticipantsModal/view';

type Props = {
    user: WaitingUserInfo;
};

/** Аватар ожидающего: фото из metadata или монограмма — одинаково в списке участников и в баннере. */
export const WaitingUserAvatar: React.FC<Props> = ({ user }) => {
    const { getCachedImage } = useCache();
    const [avatarUrl, setAvatarUrl] = useState<string>();
    const isMounted = useIsMounted();

    const displayName = getWaitingUserDisplayName(user) || '';
    const placeholder = getMonogramFromName(displayName);
    const avatarKey = user.userId || user.waitingListId;

    useEffect(() => {
        if (!user.avatar) {
            setAvatarUrl(undefined);
            return;
        }

        let cancelled = false;

        (async () => {
            const url = await getCachedImage(user.avatar ?? undefined);
            if (!cancelled && isMounted() && typeof url === 'string' && url) {
                setAvatarUrl(url);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [user.avatar, user.waitingListId, getCachedImage, isMounted]);

    return (
        <ListItemAvatar sid={avatarKey}>
            {avatarUrl ? <ListItemAvatarImage src={avatarUrl} alt={displayName} /> : placeholder}
        </ListItemAvatar>
    );
};
